import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
    Autocomplete,
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
    TextField,
    Typography,
    } from "../../ui";
import { isEmpty } from "lodash";
import { shallowEqual,
    useDispatch,
    useSelector } from "react-redux";
import {
  updateBillDetails,
    updateBillPaymentDetails,
    updateBillRiderDetails,
    } from "../../../store/billDetailsSlice";

import {
  BillStatus,
  CART_INITIAL_STATE,
  CASHPAY,
  FETCHFEWEMPLOYEE,
  getPreUrlAccordingToCart,
  GSTFEATURE,
  HOMEDELVDETAILS,
  InternalBillType,
  isNumberEmpty,
  isRoleAllowed,
  OfferType,
  ONLINEPAY,
  PayMedium,
  printDebugLog,
  SUCCESS,
  TRIP_ASSIGNED,
  TRIP_DELIVERED,
  TRIP_RUNNING,
  ROLE_VIEW,
  ROLE_CREATE,
  BILLMGMT,
  ONLINEBILLMGMT,
  CUSTOMERRIDERAPP
} from "../../../constants/constant";
import { TRIP_STATUS, TRIP_STATUS_BACK } from "./RestBillConstants";
import { snpAxios } from "../../global/api";
import {
  INITIAL_BILL_DETAILS_STATE,
} from "../../../constants/restoConstant";
import {
  getConfigValueByKey,
  getPayMedium,
} from "../../../utilities/commonUtilities";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { recalculateBillTotal } from "../../../store/thunk/billCalculatorThunk";
import CouponApply from "../../global/CouponApply";
import axios from "axios";
import PaymentDetailsDialog from "../../global/PaymentDetailsDialog";
import utilities from "../../../utilities/utilities";

const BillDetailsSection = () => {
  const {
    billItems,
    billDetails,
    billPaymentDetails,
    billRiderDetails,
    billHotelDetails,
    billCustomerDetails,
  } = useSelector((state) => state.bill, shallowEqual);
  const storeApiUrl = useSelector(
    (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL,
    shallowEqual
  );
  const storeActiveShopHash = useSelector(
    (state) => state.setActiveShopHashReducer.activeShopHash,
    shallowEqual
  );
  const restoBillConfig = useSelector(
    (state) => state.restoBillConfig,
    shallowEqual
  );

  const dispatch = useDispatch();
  const [isOtherHomeDelivery, setOtherHomeDelivery] = useState(false);
  const [riders, setRiders] = useState([]);
  const [homeDelvSplConfig, setHomeDelvSplConfig] = useState(false);
  const [isGSTDisabledDefault, setIsGSTDisabledDefault] = useState(false);
  const [bOfferType, setBOfferType] = useState(OfferType.No_Offer);
  const [billDetailsState, setBillDetailsState] = useState(
    INITIAL_BILL_DETAILS_STATE
  );

  const [showPayDialog, setShowPayDialog] = useState(false);
  const [data, setData] = useState({});
  //TODO:
  const [coupon, setCoupon] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(false);
  const { loader, snackbar, dialog } = useSnpUI();

  const getDetailedPaymentInfo = async () => {
    try {
      loader.show();
      const encodedString = utilities.encode(storeActiveShopHash.id);
      const kUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-payment-information?shopHash=${encodedString}&billNo=${billDetailsState.billNo}`;
      const response = await snpAxios.get(kUrl);
      if (response.data.status === SUCCESS) {
        setData({
          ...response.data.jcJson.data,
        })
        setShowPayDialog(true);
      }
    } catch (error) {
      console.error("getDetailedPaymentInfo", error);
    } finally {
      loader.hide();
    }
  }

  const handleShowPayDialog = async () => {
    await getDetailedPaymentInfo(billDetailsState.billNo);
  }

  useEffect(() => {
    console.log("I run on every render");
  });

  useEffect(() => {
    // 
    console.log("I run only on mount");
    console.log("billDetails from Redux:", billDetails);
    console.log("billPaymentDetails.offerType: ", billPaymentDetails.offerType);
    getRiderDetails();
    const gstConfig = getConfigValueByKey(restoBillConfig, GSTFEATURE);
    printDebugLog("gstConfig: ", gstConfig);
    if (
      gstConfig !== isGSTDisabledDefault &&
      isEmpty(billDetailsState.billNo)
    ) {
      setIsGSTDisabledDefault(gstConfig);
    }

    const homeDelvConfig = getConfigValueByKey(
      restoBillConfig,
      HOMEDELVDETAILS
    );
    if (homeDelvConfig !== homeDelvSplConfig) {
      setHomeDelvSplConfig(homeDelvConfig);
    }
    // loader.hide()
  }, []);

  useEffect(() => {
    const offerTypeFromRedux = billPaymentDetails?.offerType;
    if (offerTypeFromRedux !== bOfferType) {
      setBOfferType(offerTypeFromRedux);
    }

    console.log("Payment Details delvChg: ", billPaymentDetails.deliveryCharge);
  }, [billPaymentDetails.offerType]);

  useEffect(() => {
    const expectedGstAllowed = !isGSTDisabledDefault;
    dispatch(updateBillPaymentDetails({ isGstAllowed: expectedGstAllowed }));
    // if (billPaymentDetails.isGstAllowed !== expectedGstAllowed) {
    //   console.log("Dispatching updateBillPaymentDetails for isGstAllowed...");
    //   dispatch(updateBillPaymentDetails({ isGstAllowed: expectedGstAllowed }));
    // }
  }, [isGSTDisabledDefault]);

  useEffect(() => {
    setBillDetailsState({ ...INITIAL_BILL_DETAILS_STATE, ...billDetails });
  }, [billDetails]);

  useEffect(() => {
    //Reonly run when billPaymentDetails changes
    console.log("billPaymentDetails: ", billPaymentDetails);
    if (billPaymentDetails.coupon && !isEmpty(billPaymentDetails.coupon)) {
      setCoupon(billPaymentDetails.coupon);
      setAppliedCoupon(true);
    }
  }, [billPaymentDetails]);

  const handleTripStatusChange = useCallback(
    (val) => {
      const currentTripStatus = billDetailsState.pTripStatus; // why??
      const mCurrentValue = TRIP_STATUS_BACK.find((item) => item.name === val);
      const myPreviousValue = TRIP_STATUS_BACK.find(
        (item) => item.name === currentTripStatus
      );

      if (isEmpty(currentTripStatus)) {
        // When Trip is not assigned
        if (
          TRIP_ASSIGNED === val &&
          billDetailsState.billType !== InternalBillType.Home
        ) {
          snackbar.show({
            message: "Feature support only in Home delivery",
            color: "red",
          });
        } else {
          dispatch(
            updateBillDetails({
              tripStatus: isEmpty(val) ? billDetailsState.pTripStatus : val,
            })
          );
          setBillDetailsState({
            ...billDetailsState,
            tripStatus: isEmpty(val) ? billDetailsState.pTripStatus : val,
          });
        }
      } else if (currentTripStatus === TRIP_RUNNING && mCurrentValue?.no < 5) {
        // Prevent updates to previous statuses when Trip is running
        snackbar.show({
          message: `Cannot Update previous Trip status (i.e. ${mCurrentValue?.name}) Current Status: ${currentTripStatus}`,
          color: "red",
        });
      } else if (myPreviousValue?.no > mCurrentValue?.no) {
        // Prevent updates to earlier statuses
        snackbar.show({
          message: `Cannot Update previous Trip status (i.e. ${mCurrentValue?.name}) Current Status: ${currentTripStatus}`,
          color: "red",
        });
      } else {
        dispatch(
          updateBillDetails({
            tripStatus: isEmpty(val) ? billDetailsState.pTripStatus : val,
          })
        );
      }
    },
    [billDetailsState, billDetails.billType]
  );

  const handleOnlineSelectChange = (event, payMethod) => {
    printDebugLog("handleOnlineSelectChange", event, payMethod);
    let onlinePayMethod;
    if (payMethod != null) {
      onlinePayMethod = payMethod;
    } else {
      onlinePayMethod = "";
    }
    dispatch(
      updateBillPaymentDetails({
        onlinePayMedium: onlinePayMethod,
      })
    );
  };
  const getGlobalVoucherCheck = async () => {
    try {
      let m_payType = "";
      if (billPaymentDetails.payMedium === PayMedium.ONLINE) {
        m_payType = billPaymentDetails.onlinePayMedium;
      } else if (billPaymentDetails.payMedium === PayMedium.CASH) {
        m_payType = CASHPAY;
      } else if (billPaymentDetails.payMedium === PayMedium.BOTH) {
        m_payType = CASHPAY + "-" + billPaymentDetails.onlinePayMedium;
      }
      const params = {
        shopHash: storeActiveShopHash.id,
        voucherCode: coupon,
        amt: billPaymentDetails.totalPrice,
        mob: billCustomerDetails.custMob,
        email: billCustomerDetails.custEmail,
        billType: billDetailsState.billType,
        payType: m_payType,
        deliveryType: billPaymentDetails.delvName,
      };

      const query = Object.entries(params)
        .filter(([_, v]) => v !== undefined && v !== null && v !== "")
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join("&");
      printDebugLog("getGlobalVoucherCheck:query", query);
      const dUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(
        storeActiveShopHash.cartType
      )}a2z-global-voucher-check?${query}`;
      const response = await axios.get(dUrl);
      printDebugLog("getGlobalVoucherCheck", response.data);
      if (response.data.status === SUCCESS) {
        handleCouponUpdate(
          true,
          response.data.jcJson.offerType,
          response.data.jcJson.offerAmt,
          coupon
        );
      } else {
        const errorMessage = response.data.errorMessage;
        dialog.show({
          negativeReq: true,
          title: "Error",
          subTitle: errorMessage,
          negativeAction: "Dismiss",
          cancelExtra: true,
          requestType: 99,
        });
      }
    } catch (err) {
      console.error("getGlobalVoucherCheck", err);
      dialog.show({
        negativeReq: true,
        title: "Error",
        subTitle: "Network Error Try again",
        negativeAction: "Dismiss",
        cancelExtra: true,
        requestType: 99,
      });
    }
  };

  const handleCouponUpdate = (couponApplied, offerType, offerValue, coupon) => {
    printDebugLog("handleCouponUpdate", couponApplied);
    setAppliedCoupon(couponApplied);
    dispatch(
      updateBillPaymentDetails({
        offerValue: Number(offerValue),
        offerType: Number(offerType),
        coupon: coupon,
      })
    );
    dispatch(recalculateBillTotal({ shouldClearPaymentDetails: false }));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log("handleInputChange: ", name, value);
    //printLog("handleInputChange", event.target);
    if (name === "offerType") {
      //TODO: Itemwise offer
    } else if (name === "offerValue") {
      //TODO: Itemwise offer
    } else if (name === "cashTender") {
      const digitsOnly = value.replace(/\D+/g, "").replace(/^0+(?=\d)/, "");
      if (billPaymentDetails.finalPrice > 0.0) {
        let tot = 0.0;
        if (billPaymentDetails.isOnlinePayEnabled)
          tot = billPaymentDetails.cashPay;
        else tot = billPaymentDetails.finalPrice;
        let rt = parseFloat(digitsOnly) - tot;

        if (rt >= 0.0) {
          dispatch(
            updateBillPaymentDetails({
              cashTender: parseFloat(digitsOnly),
              cashReturn: rt,
            })
          );
        } else {
          // setPaymentDetails({
          //   ...paymentDetails,
          //   cashTender: value,
          //   cashReturn: 0.0,
          // });
          dispatch(
            updateBillPaymentDetails({
              cashTender: digitsOnly,
              cashReturn: rt,
            })
          );
          if (rt < 0.0) {
            snackbar.show({
              message:
                "Cash Tender should be more or same as Total Amount i.e " + tot,
              color: "orange",
            });
          }
        }
      } else {
        snackbar.show({
          message: "Please add Dish to start Bill process",
          color: "red",
        });
        // setPaymentDetails({
        //   cashTender: 0.0,
        //   cashReturn: 0.0,
        // });
        dispatch(
          updateBillPaymentDetails({
            cashTender: 0.0,
            cashReturn: 0.0,
          })
        );
      }
    } else if (name === "rate-select") {
      // printDebugLog("rate-select", value, stockSingleData);
      // updateStockPrice(
      //   parseFloat(event.target.id),
      //   billStockData.offerType,
      //   billStockData.offerValue,
      //   billStockData.quantity,
      //   value
      // );
    } else if (name === "onlinePay") {
      let val = !billPaymentDetails.isOnlinePayEnabled;
      let rt = parseFloat(billPaymentDetails.finalPrice);
      let offerDetails = {};
      if (appliedCoupon) {
        setAppliedCoupon(false);
        offerDetails = {
          offerValue: 0.0,
          offerType: OfferType.No_Offer,
          coupon: "",
        };
      }
      dispatch(
        updateBillPaymentDetails({
          onlinePayThrough: val ? value : "",
          onlinePayMedium: val ? CART_INITIAL_STATE.onlinePayMethod[0] : "",
          payMedium: getPayMedium(billPaymentDetails.isCashPayEnabled, val),
          onlinePay: !val
            ? 0.0
            : billPaymentDetails.isCashPayEnabled
              ? rt > 0
                ? rt / 2
                : 0.0
              : rt,
          cashPay: !billPaymentDetails.isCashPayEnabled
            ? 0.0
            : val
              ? rt > 0
                ? rt / 2
                : 0.0
              : rt,
          isOnlinePayEnabled: val,
          // coupon: isEmpty(coupon) ? "" : coupon,
          coupon: "",
          ...offerDetails,
        })
      );
      setAppliedCoupon(false);
      // setPaymentDetails({
      //   onlinePayThrough: val ? value : "",
      //   onlinePayMedium: val ? CART_INITIAL_STATE.onlinePayMethod[0] : "",
      //   payMedium: getPayMedium(billPaymentDetails.isCashPayEnabled, val),
      //   onlinePay: !val
      //     ? 0.0
      //     : billPaymentDetails.isCashPayEnabled
      //     ? rt > 0
      //       ? rt / 2
      //       : 0.0
      //     : rt,
      //   cashPay: !billPaymentDetails.isCashPayEnabled
      //     ? 0.0
      //     : val
      //     ? rt > 0
      //       ? rt / 2
      //       : 0.0
      //     : rt,
      //   isOnlinePayEnabled: val,
      // });
    } else if (name === "onlinePayAmt") {
      if (isNumberEmpty(value)) {
        let rt = parseFloat(billPaymentDetails.finalPrice);
        dispatch(
          updateBillPaymentDetails({
            onlinePay: 0.0,
            cashPay: billPaymentDetails.isCashPayEnabled ? rt : 0.0,
            cashTender: 0.0,
            cashReturn: 0.0,
            payMedium: getPayMedium(billPaymentDetails.isCashPayEnabled, true),
          })
        );
        //local state update
        // setPaymentDetails({
        //   ...paymentDetails,
        //   onlinePay: 0.0,
        //   cashPay: billPaymentDetails.isCashPayEnabled ? rt : 0.0,
        //   cashTender: 0.0,
        //   cashReturn: 0.0,
        //   payMedium: getPayMedium(billPaymentDetails.isCashPayEnabled, true),
        // });
        // setOnlinePayEnb(true);
      } else {
        let rt = parseFloat(billPaymentDetails.finalPrice);

        if (parseFloat(value) > rt) {
          snackbar.show({
            message: "Exceeds Total Amount i.e " + rt,
            color: "red",
          });
        } else {
          let mOnlinePay = Number(value);
          let mCashPay = billPaymentDetails.isCashPayEnabled
            ? rt - mOnlinePay
            : 0.0;
          let mOnlinePayEnb = mOnlinePay !== 0.0;
          let mCashPayEnb = mCashPay !== 0.0;
          printDebugLog("onlinePayAmt", value, rt, mCashPay);
          dispatch(
            updateBillPaymentDetails({
              onlinePay: mOnlinePay,
              cashPay: mCashPay,
              cashPayThrough: !mCashPayEnb
                ? ""
                : billPaymentDetails.cashPayThrough,
              onlinePayMedium: !mOnlinePayEnb
                ? ""
                : billPaymentDetails.onlinePayMedium,
              cashTender: 0.0,
              cashReturn: 0.0,
              payMedium: getPayMedium(mCashPayEnb, mOnlinePayEnb),
            })
          );
          // setPaymentDetails({
          //   ...paymentDetails,
          //   onlinePay: mOnlinePay,
          //   cashPay: mCashPay,
          //   cashPayThrough: !mCashPayEnb ? "" : billPaymentDetails.cashPayThrough,
          //   onlinePayMedium: !mOnlinePayEnb
          //     ? ""
          //     : billPaymentDetails.onlinePayMedium,
          //   cashTender: 0.0,
          //   cashReturn: 0.0,
          //   payMedium: getPayMedium(mCashPayEnb, mOnlinePayEnb),
          // });
          // setOnlinePayEnabled(mOnlinePayEnb);
          // setCashPayEnabled(mCashPayEnb);
        }
      }
    } else if (name === "cashPayAmt") {
      printDebugLog("cashPayAmt", value);
      if (isNumberEmpty(value)) {
        // why should we update anything if the amount is empty??
        console.log("cashAmt total: ", billPaymentDetails.finalPrice);

        let rt = parseFloat(billPaymentDetails.finalPrice);
        dispatch(
          updateBillPaymentDetails({
            cashPay: 0.0,
            onlinePay: billPaymentDetails.isOnlinePayEnabled ? rt : 0.0,
            cashTender: value.replace(/\D+/g, "").replace(/^0+(?=\d)/, ""),
            cashReturn: 0.0,
            payMedium: getPayMedium(
              true,
              billPaymentDetails.isOnlinePayEnabled
            ),
          })
        );
        // setPaymentDetails({
        //   ...paymentDetails,
        //   cashPay: 0.0,
        //   onlinePay: billPaymentDetails.isOnlinePayEnabled ? rt : 0.0,
        //   cashTender: value,
        //   cashReturn: 0.0,
        //   payMedium: getPayMedium(true, billPaymentDetails.isOnlinePayEnabled),
        // });
        //setCashPayEnabled(true);
      } else {
        let rt = parseFloat(billPaymentDetails.finalPrice);
        if (parseFloat(value) > rt) {
          snackbar.show({
            message: "Exceeds Total Amount i.e " + rt,
            color: "red",
          });
        } else {
          let mCashPay = Number(value);
          let mOnlinePay = billPaymentDetails.isOnlinePayEnabled
            ? rt - mCashPay
            : 0.0;
          let mOnlinePayEnb = mOnlinePay !== 0.0;
          let mCashPayEnb = mCashPay !== 0.0;
          dispatch(
            updateBillPaymentDetails({
              cashPay: mCashPay,
              onlinePay: mOnlinePay,
              onlinePayThrough: !mOnlinePayEnb
                ? ""
                : billPaymentDetails.onlinePayThrough,
              onlinePayMedium: !mOnlinePayEnb
                ? ""
                : billPaymentDetails.onlinePayMedium,
              cashTender: 0.0,
              cashReturn: 0.0,
              payMedium: getPayMedium(mCashPayEnb, mOnlinePayEnb),
            })
          );
          // setPaymentDetails({
          //   ...paymentDetails,
          //   cashPay: mCashPay,
          //   onlinePay: mOnlinePay,
          //   onlinePayThrough: !mOnlinePayEnb
          //     ? ""
          //     : billPaymentDetails.onlinePayThrough,
          //   onlinePayMedium: !mOnlinePayEnb
          //     ? ""
          //     : billPaymentDetails.onlinePayMedium,
          //   cashTender: 0.0,
          //   cashReturn: 0.0,
          //   payMedium: getPayMedium(mCashPayEnb, mOnlinePayEnb),
          // });

          // setOnlinePayEnabled(mOnlinePayEnb);
          // setCashPayEnabled(mCashPayEnb);
        }
      }
    } else if (name === "cashPay") {
      let val = !billPaymentDetails.isCashPayEnabled;
      let rt = parseFloat(billPaymentDetails.finalPrice);
      let offerDetails = {};
      if (appliedCoupon) {
        setAppliedCoupon(false);
        offerDetails = {
          offerValue: 0.0,
          offerType: OfferType.No_Offer,
          coupon: "",
        };
      }
      dispatch(
        updateBillPaymentDetails({
          cashPayThrough: val ? value : "",
          cashPay: !val
            ? 0.0
            : billPaymentDetails.isOnlinePayEnabled
              ? rt > 0
                ? rt / 2
                : 0.0
              : rt,
          onlinePay: !billPaymentDetails.isOnlinePayEnabled
            ? 0.0
            : val
              ? rt > 0
                ? rt / 2
                : 0.0
              : rt,
          payMedium: getPayMedium(val, billPaymentDetails.isOnlinePayEnabled),
          isCashPayEnabled: val,
          ...offerDetails,
        })
      );
      setAppliedCoupon(false);
      // setPaymentDetails({
      //   cashPayThrough: val ? value : "",
      //   cashPay: !val
      //     ? 0.0
      //     : billPaymentDetails.isOnlinePayEnabled
      //     ? rt > 0
      //       ? rt / 2
      //       : 0.0
      //     : rt,
      //   onlinePay: !billPaymentDetails.isOnlinePayEnabled
      //     ? 0.0
      //     : val
      //     ? rt > 0
      //       ? rt / 2
      //       : 0.0
      //     : rt,
      //   payMedium: getPayMedium(val, billPaymentDetails.isOnlinePayEnabled),
      //   isCashPayEnabled: val,
      // });
      //setCashPayEnabled(val);
    } else if (name === "isGstAllowed") {
      let val = event.target.checked;
      printDebugLog("isGstAllowed val", val);
      printDebugLog("isGstAllowed ", billPaymentDetails.isGstAllowed);
      dispatch(updateBillPaymentDetails({ isGstAllowed: val }));
      reCalculateBillTotal();
    } else if (name === "delvNameOth") {
      // setPaymentDetails({ ...paymentDetails, delvNameOth: value });
      dispatch(
        updateBillPaymentDetails({
          delvNameOth: value,
        })
      );
    } else if (name === "deliveryCharge") {
      const delvCharge = parseFloat(value);
      //setPaymentDetails({ ...paymentDetails, deliveryCharge: delvCharge });
      dispatch(
        updateBillPaymentDetails({
          deliveryCharge: delvCharge ? delvCharge : 0.0,
        })
      );
      if (billItems && billItems.length > 0) {
        reCalculateBillTotal();
      }
    } else if (name === "bOfferType") {
      console.log("bOfferType: ", value);

      setBOfferType(Number(value));
      dispatch(
        updateBillPaymentDetails({
          offerType: Number(value),
        })
      );
      reCalculateBillTotal();
    } else if (name === "bofferValue") {
      const sanitized = sanitizeDecimal(value, 2); // 2 decimals
      dispatch(
        updateBillPaymentDetails({
          offerValue: sanitized,
        })
      );
      reCalculateBillTotal();
    }
  };

  const sanitizeDecimal = (raw, maxDecimals = 2) => {
    if (raw == null) return "";
    let v = String(raw);

    // Keep digits and dots only
    v = v.replace(/[^0-9.]/g, "");

    // Keep only the first dot
    const firstDot = v.indexOf(".");
    if (firstDot !== -1) {
      v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, "");
    }

    // Strip leading zeros but preserve "0."
    v = v.replace(/^0+(?=\d)/, "");
    if (v.startsWith(".")) v = "0" + v;

    // Remember if user ended with a dot (e.g., "6.")
    const endsWithDot = v.endsWith(".");

    // Limit decimal places
    const dot = v.indexOf(".");
    if (dot !== -1) {
      const intPart = v.slice(0, dot);
      const decPart = v.slice(dot + 1, dot + 1 + maxDecimals);
      v = intPart + (endsWithDot ? "." : decPart ? "." + decPart : "");
    }

    return v;
  };

  const handleDelvSelectChange = (event, homeDelvMethod) => {
    if (homeDelvMethod) {
      const isOther = homeDelvMethod === "Other";
      printDebugLog(
        "::handleDelvSelectChange::",
        event,
        homeDelvMethod,
        billPaymentDetails.finalPrice
      );
      // setPaymentDetails((prevDetails) => ({
      //   delvName: homeDelvMethod,
      //   delvNameOth: "",
      //   onlinePayMedium: "Other",
      //   onlinePayThrough: ONLINEPAY,
      //   onlinePay: Number(billPaymentDetails.finalPrice),
      //   cashPay: 0.0,
      //   payMedium: PayMedium.ONLINE,
      // }));

      dispatch(
        updateBillPaymentDetails({
          delvName: homeDelvMethod,
          delvNameOth: "",
          onlinePayMedium: "Other",
          onlinePayThrough: ONLINEPAY,
          onlinePay: Number(billPaymentDetails.finalPrice),
          cashPay: 0.0,
          payMedium: PayMedium.ONLINE, // will it be always online??
          isOnlinePayEnabled: true,
        })
      );
      setOtherHomeDelivery(isOther);

      // setBillingData((prevBillingData) => ({
      //     ...prevBillingData,
      //     onlineBillOtherName: payMethod,
      // }));
      // what is this onlineBillOtherName
      // setDelvNameOth(isOther ? "" : payMethod);
      // setIsOtherHomeDelv(isOther);
      // setOnlinePayEnb(true);
    } else {
      dispatch(
        updateBillPaymentDetails({
          deliveryCharge: 0.0,
          delvName: "",
          delvNameOth: "",
          onlinePayMedium: "",
          onlinePayThrough: "",
          onlinePay: 0.0,
          cashPay: 0.0,
          payMedium: PayMedium.NOPAY,
          isOnlinePayEnabled: false,
        })
      );

      setOtherHomeDelivery(false);
      // setOnlinePayEnb(false);
    }
  };
  const getRiderDetails = async () => {
    let cartUrl = storeApiUrl.BACKEND_BASE_URL + FETCHFEWEMPLOYEE;
    let data = {
      jcJson: {
        apiToken: CART_INITIAL_STATE.apiToken,
        shopHash: storeActiveShopHash.id,
        roleFeature: CUSTOMERRIDERAPP, rolePermission: ROLE_VIEW,
        lookInTripReq: true,
      },
    };
    //  console.log("getRestoDetails  => ",data);
    snpAxios
      .post(cartUrl, data)
      .then((response) => {
        console.log("response  => ", response.data);
        console.log("response riders => ", response.data.jcJson.value_2);
        if (response.data.status === SUCCESS) {
          const ridersData = response.data.jcJson.value_2;
          const riderDetails =
            ridersData &&
            ridersData.length > 0 &&
            ridersData.map((rider) => {
              return {
                riderId: rider.id,
                riderName: rider.name,
                mobile: rider.mob,
              };
            });
          setRiders(riderDetails);
          //dispatch(updateBillRiderDetails(response.data.jcJson.value_2));
        }
      })
      .catch((error) => {
        console.log("errr ", error);
        //window.location.href = "#/error";
      });
  };

  const reCalculateBillTotal = () => {
    const billTotalSummary = {
      prevTotalPrice: 0.0,
      newTotalPrice: 0.0,
    };
    dispatch(recalculateBillTotal(billTotalSummary));
  };

  const renderHomeDeliveryAutocomplete = () => {
    console.log("billDetailsState.billType: ", billDetailsState.billType);

    if (billDetailsState.billType !== InternalBillType.Home) {
      return null; // Avoid rendering if the condition isn't met
    }

    printDebugLog("Rendering Autocomplete because of dependency changes");

    return (
      <Grid
        item
        md={isOtherHomeDelivery ? 4 : 6}
        xs={12}
        lg={isOtherHomeDelivery ? 4 : 6}
        sm={6}
      >
        <Autocomplete
          id="home-select"
          options={CART_INITIAL_STATE.homeDelvMethod}
          autoHighlight
          variant="filled"
          size="small"
          disabled={billDetails.isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
          style={{ width: "90%", maxHeight: "20%" }}
          onChange={handleDelvSelectChange}
          isOptionEqualToValue={(option, value) => {
            if (!option || !value) return false;
            return option === value;
          }}
          getOptionLabel={(option) => option ?? ""}
          defaultValue={billPaymentDetails.delvName}
          value={billPaymentDetails.delvName}
          renderOption={(props, option) => (
            <Box component="li" {...props}>
              {option}
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Home Delivery"
              inputProps={{
                ...params.inputProps,
              }}
            />
          )}
        />
      </Grid>
    );
  };

  const isTripStatusAvailable = useMemo(() => {
    return billDetailsState.tripUpdateReq || billDetailsState.billedFrom === 0;
  }, [billDetailsState.tripUpdateReq, billDetailsState.billedFrom === 0]);

  const renderTripStatusAutoComplete = useMemo(() => {
    return (
      isTripStatusAvailable && (
        <Grid item xs={12} md={6} sm={6} lg={6}>
          <Autocomplete
            id="trip-select"
            options={TRIP_STATUS}
            disabled={TRIP_DELIVERED === billDetailsState.pTripStatus}
            autoHighlight
            variant="filled"
            size="small"
            onChange={(e, val) => handleTripStatusChange(val)}
            style={{ width: "90%", maxHeight: "20%" }}
            isOptionEqualToValue={(option, value) => option === value}
            getOptionLabel={(option) => option || ""}
            value={billDetailsState.tripStatus}
            renderOption={(props, option) => (
              <Box component="li" {...props}>
                {option}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Update Trip/Food Status"
                placeholder="Select Trip/Food Status"
                inputProps={{ ...params.inputProps }}
              />
            )}
          />
        </Grid>
      )
    );
  }, [
    isTripStatusAvailable,
    billDetailsState.pTripStatus,
    billDetailsState.tripStatus,
    handleTripStatusChange,
  ]);

  const handleRiderChange = useCallback(
    (val) => {
      const riderId = val?.riderId || "";
      const riderName = val?.riderName || "";
      const mobile = val?.mobile || "";
      dispatch(
        updateBillRiderDetails({
          riderId: riderId,
          riderName: riderName,
          mobile: mobile,
        })
      );
    },
    [dispatch]
  );

  const isRiderSelectAvailable = useMemo(() => {
    return (
      riders &&
      riders.length > 0 &&
      billDetailsState.billType === InternalBillType.Home &&
      [TRIP_ASSIGNED, TRIP_RUNNING, TRIP_DELIVERED].includes(
        billDetailsState.tripStatus
      )
    );
  }, [
    riders,
    billDetailsState.billType,
    billDetailsState.tripStatus,
    billDetails.tripStatus,
  ]);
  //optimize it

  const renderRiderSelectAutocomplete = useMemo(() => {
    return (
      isRiderSelectAvailable && (
        <Grid item xs={12} md={6} sm={6} lg={6}>
          <Autocomplete
            id="rider-select"
            options={riders}
            autoHighlight
            disabled={TRIP_DELIVERED === billDetailsState.pTripStatus}
            variant="filled"
            size="small"
            onChange={(e, val) => handleRiderChange(val)}
            style={{ width: "90%", maxHeight: "20%" }}
            isOptionEqualToValue={(option, value) =>
              option?.riderId === value?.riderId
            }
            getOptionLabel={(option) => option?.riderName ?? ""}
            value={billRiderDetails}
            renderOption={(props, option) => (
              <Box component="li" {...props}>
                {`${option.riderName} (${option.mobile})`}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Assigned Rider"
                helperText={
                  isEmpty(billDetailsState.assignedByName)
                    ? ""
                    : `Assigned By ${billDetailsState.assignedByName}`
                }
                placeholder="Select Rider"
                inputProps={{
                  ...params.inputProps,
                }}
              />
            )}
          />
        </Grid>
      )
    );
  }, [
    isRiderSelectAvailable,
    billDetailsState.pTripStatus,
    billDetailsState.tripStatus,
    billRiderDetails,
    billDetailsState.assignedByName,
    handleRiderChange,
  ]);

  // const updateBillingData = (val) => {
  //   setBillingData({
  //     ...billDetails,
  //     tripStatus: isEmpty(val) ? billDetails.pTripStatus : val,
  //   });
  // };

  return (
    <div>
      <Grid container spacing={0} className="summary summary-section">
        <Grid item md={9} xs={12} lg={9} sm={7}>
          <Grid container spacing={0.5}>
            <Grid item md={12} xs={12} lg={12} sm={12}>
              <Typography
                variant="subtitle4"
                component="div"
                style={{
                  color: "#2f1160",
                  whiteSpace: "pre-wrap",
                  overflowWrap: "break-word",
                  fontSize: "23px",
                }}
              >
                <u>Bill Option:</u>
              </Typography>
            </Grid>
            <Grid item md={2} xs={12} lg={2} sm={4}>
              <FormControlLabel
                name="isGstAllowed"
                disabled={billDetails.isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                //checked={billPaymentDetails.isGstAllowed || isGSTEnabledDefault}
                control={
                  <Checkbox
                    name="isGstAllowed"
                    checked={!!billPaymentDetails.isGstAllowed}
                    onChange={handleInputChange}
                  />
                }
                label={
                  <Box component="div" fontSize={15}>
                    {billPaymentDetails.isGstAllowed
                      ? "Disable GST"
                      : "Enable GST"}
                  </Box>
                }
              />
            </Grid>
            <Grid item xs={12} md={10} lg={10} sm={8}>
              <FormControl>
                <CouponApply
                  isPaid={billDetails.isPaid}
                  isRoleAllowed={isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                  coupon={coupon}
                  appliedCoupon={appliedCoupon}
                  setCoupon={(val) => setCoupon(val)}
                  handleApply={() => {
                    if (!isEmpty(coupon)) {
                      getGlobalVoucherCheck();
                    } else {
                      dialog.show({
                        negativeReq: true,
                        title: "Error",
                        subTitle: "Please enter coupon first",
                        negativeAction: "Ok",
                        cancelExtra: true,
                        requestType: 99,
                      });
                    }
                  }}
                  handleRemove={() => {
                    handleCouponUpdate(false, OfferType.No_Offer, 0.0, "");
                  }}
                />
                <FormLabel id="billOffer">Any Offer :</FormLabel>
                <RadioGroup
                  row
                  aria-label="bOfferType"
                  disabled={
                    billDetails.isPaid ||
                    appliedCoupon ||
                    !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
                  }
                  name="bOfferType"
                  value={bOfferType}
                  onChange={handleInputChange}
                >
                  <FormControlLabel
                    disabled={
                      billDetails.isPaid ||
                      appliedCoupon ||
                      !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
                    }
                    value={OfferType.No_Offer}
                    control={<Radio />}
                    label="No Offer"
                  />
                  <FormControlLabel
                    disabled={
                      billDetails.isPaid ||
                      appliedCoupon ||
                      !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
                    }
                    value={OfferType.Flat}
                    control={<Radio />}
                    label="Flat"
                  />
                  <FormControlLabel
                    disabled={
                      billDetails.isPaid ||
                      appliedCoupon ||
                      !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
                    }
                    value={OfferType.Percentage}
                    control={<Radio />}
                    label="In Percentage"
                  />
                  {billPaymentDetails.offerType > 1 && (
                    <div>
                      <TextField
                        id="bofferValue"
                        name="bofferValue"
                        variant="filled"
                        size="small"
                        type="text" // <— text for full control
                        inputProps={{
                          inputMode: "decimal", // iOS & Android decimal keypad
                          pattern: "[0-9]*[.,]?[0-9]*", // optional regex: allow decimals
                        }}
                        disabled={
                          billDetails.isPaid ||
                          appliedCoupon ||
                          !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
                        }
                        label="Enter Offer Value"
                        value={billPaymentDetails.offerValue}
                        onChange={handleInputChange}
                        style={{ width: "60%" }}
                      />
                    </div>
                  )}
                </RadioGroup>
              </FormControl>
            </Grid>
            {renderHomeDeliveryAutocomplete()}
            {isOtherHomeDelivery && (
              <Grid item md={4} xs={12} lg={4} sm={6}>
                <TextField
                  id="delvNameOth"
                  name="delvNameOth"
                  variant="filled"
                  size="small"
                  disabled={billDetails.isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                  label="Enter Other Delivery Name"
                  //value={delvNameOth}
                  onChange={handleInputChange}
                />
              </Grid>
            )}
            {!isEmpty(billPaymentDetails.delvName) && (
              <Grid
                item
                md={isOtherHomeDelivery ? 4 : 6}
                xs={12}
                lg={isOtherHomeDelivery ? 4 : 6}
                sm={6}
              >
                <TextField
                  id="deliveryCharge"
                  name="deliveryCharge"
                  variant="filled"
                  size="small"
                  disabled={billDetails.isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                  label="Enter Delivery Amount"
                  value={billPaymentDetails.deliveryCharge}
                  onChange={handleInputChange}
                />
              </Grid>
            )}
            {homeDelvSplConfig && !isEmpty(billPaymentDetails.delvName) && (
              <Grid item md={6} xs={12} lg={6} sm={6}>
                <TextField
                  id="homeDelvId"
                  name="homeDelvId"
                  variant="filled"
                  size="small"
                  disabled={billDetails.isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                  label="Enter Delivery OrderId"
                  value={billDetailsState.homeDelvId}
                  onChange={(e) =>
                    dispatch(
                      updateBillDetails({
                        homeDelvId: e.target.value,
                      })
                    )
                  }
                />
              </Grid>
            )}
            {homeDelvSplConfig && !isEmpty(billPaymentDetails.delvName) && (
              <Grid item md={6} xs={12} lg={6} sm={6}>
                <TextField
                  id="homeDelvOtp"
                  name="homeDelvOtp"
                  variant="filled"
                  size="small"
                  disabled={billDetails.isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                  label="Enter Delivery OTP"
                  value={billDetailsState.homeDelvOtp}
                  onChange={(e) =>
                    dispatch(
                      updateBillDetails({
                        homeDelvOtp: e.target.value,
                      })
                    )
                  }
                />
              </Grid>
            )}
            {renderTripStatusAutoComplete}
            {/* https://mui.com/material-ui/react-autocomplete/ */}
            {renderRiderSelectAutocomplete}
            <Grid item md={12} xs={12} sm={12}>
              <Typography
                variant="subtitle4"
                component="div"
                style={{
                  color: "#2f1160",
                  whiteSpace: "pre-wrap",
                  overflowWrap: "break-word",
                  fontSize: "23px",
                }}
              >
                <u>Payment Methods:</u>
              </Typography>
            </Grid>
            <Grid item xs={12} md={2} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="onlinePay"
                    value={ONLINEPAY}
                    checked={!!billPaymentDetails.isOnlinePayEnabled}
                    onChange={handleInputChange}
                  />
                }
                label="Online"
                disabled={billDetails.isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
              />
            </Grid>
            <Grid item xs={12} md={5} sm={6}>
              <Autocomplete
                id="online-select"
                options={CART_INITIAL_STATE.onlinePayMethod}
                autoHighlight
                variant="filled"
                size="small"
                fullWidth
                isOptionEqualToValue={(option, value) => {
                  if (!option) return false;
                  if (!value) return false;
                  return option === value;
                }}
                disabled={
                  billDetails.isPaid ||
                  !billPaymentDetails.isOnlinePayEnabled ||
                  !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
                }
                style={{ width: "70%", maxHeight: "20%" }}
                onChange={handleOnlineSelectChange}
                getOptionLabel={(option) => option ?? ""}
                value={billPaymentDetails.onlinePayMedium}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Online Pay Method"
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={5} sm={6}>
              <TextField
                id="onlinePayAmt"
                name="onlinePayAmt"
                variant="filled"
                size="small"
                inputProps={{
                  inputMode: "decimal", // iOS & Android decimal keypad
                  pattern: "[0-9]*[.,]?[0-9]*", // optional regex: allow decimals
                }}
                style={{ width: "70%", maxHeight: "20%" }}
                disabled={
                  billDetails.isPaid ||
                  !billPaymentDetails.isOnlinePayEnabled ||
                  !billPaymentDetails.isCashPayEnabled ||
                  !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
                }
                label="Enter Online Amount"
                value={billPaymentDetails.onlinePay}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={2} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="cashPay"
                    value={CASHPAY}
                    checked={!!billPaymentDetails.isCashPayEnabled}
                    onChange={handleInputChange}
                  />
                }
                label="Cash"
                disabled={
                  billDetails.isPaid ||
                  billDetailsState.billType === InternalBillType.Home ||
                  !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
                }
              />
            </Grid>
            <Grid item xs={12} md={5} sm={6}>
              <TextField
                id="cashPayAmt"
                name="cashPayAmt"
                variant="filled"
                size="small"
                style={{ width: "70%" }}
                inputProps={{
                  inputMode: "decimal", // iOS & Android decimal keypad
                  pattern: "[0-9]*[.,]?[0-9]*", // optional regex: allow decimals
                }}
                disabled={
                  billDetails.isPaid ||
                  !billPaymentDetails.isOnlinePayEnabled ||
                  !billPaymentDetails.isCashPayEnabled ||
                  !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
                }
                label="Enter Cash Amount"
                value={billPaymentDetails.cashPay}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
          {billDetailsState.payAtCounterOpt && (
            <Grid item md={12} xs={12} sm={12} lg={12}>
              <center>
                <p
                  style={{
                    whiteSpace: "pre-wrap",
                    overflowWrap: "break-word",
                    fontSize: "16px",
                  }}
                >
                  <u>** Note : User Choose to Pay At Counter **</u>
                </p>
              </center>
            </Grid>
          )}
          {!isEmpty(billHotelDetails.roomNo) &&
            billDetailsState.payLaterSignal && (
              <Grid item md={12} xs={12} sm={12} lg={12}>
                <center>
                  <p
                    style={{
                      whiteSpace: "pre-wrap",
                      overflowWrap: "break-word",
                      fontSize: "16px",
                    }}
                  >
                    <u>
                      ** Note : Payment of this bill will take care by Hotel
                      Payment **
                    </u>
                  </p>
                </center>
              </Grid>
            )}
          {!isEmpty(billDetailsState.transactionId) && (
            <Grid item md={12} xs={12} sm={12} lg={12}>
              <center>
                <p
                  style={{
                    whiteSpace: "pre-wrap",
                    overflowWrap: "break-word",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleShowPayDialog();
                  }}
                >
                  <u>** Transaction Id : {billDetailsState.transactionId} (Click Here)**</u>
                </p>
              </center>
            </Grid>
          )}
          {billDetailsState.billStatus === BillStatus.HOMEDELIVERYINITIATED && (
            <Grid item md={12} xs={12} sm={12} lg={12}>
              <center>
                <p
                  style={{
                    whiteSpace: "pre-wrap",
                    overflowWrap: "break-word",
                    fontSize: "16px",
                  }}
                >
                  <u>
                    ** Failed to Initiate Pay By Customer,You can delete the
                    bill **
                  </u>
                </p>
              </center>
            </Grid>
          )}
          {billDetailsState.billStatus === BillStatus.HOMEDELIVERYCASHPAY && (
            <Grid item md={12} xs={12} sm={12} lg={12}>
              <center>
                <p
                  style={{
                    whiteSpace: "pre-wrap",
                    overflowWrap: "break-word",
                    fontSize: "16px",
                  }}
                >
                  <u>** Customer Selected Cash on Delivery **</u>
                </p>
              </center>
            </Grid>
          )}
          {billDetailsState.billStatus === BillStatus.PARTIALLYPAID && (
            <Grid item md={12} xs={12} sm={12} lg={12}>
              <center>
                <p
                  style={{
                    whiteSpace: "pre-wrap",
                    overflowWrap: "break-word",
                    fontSize: "16px",
                    color: "#2f1160",
                  }}
                >
                  <u>
                    ** Partially Paid. To Check status click on Partial
                    Pay/Clear Dues **
                  </u>
                </p>
              </center>
            </Grid>
          )}
          {billDetailsState.billStatus === BillStatus.PAID &&
            billDetailsState.settleDown && (
              <Grid item md={12} xs={12} sm={12} lg={12}>
                <center>
                  <p
                    style={{
                      whiteSpace: "pre-wrap",
                      overflowWrap: "break-word",
                      fontSize: "16px",
                    }}
                  >
                    <u>** Full Paid & Settled **</u>
                  </p>
                </center>
              </Grid>
            )}
          {(billDetailsState.billedFrom === -1 ||
            billDetailsState.billedFrom === 1) &&
            billDetailsState.billType !== InternalBillType.BookTable &&
            billDetails.isPaid &&
            !billDetailsState.settleDown && (
              <Grid item md={12} xs={12} sm={12} lg={12}>
                <center>
                  <p
                    style={{
                      whiteSpace: "pre-wrap",
                      overflowWrap: "break-word",
                      fontSize: "16px",
                      color: "#641906",
                    }}
                  >
                    <u>
                      ** Full Paid & But not settled. Please settle the bill **
                    </u>
                  </p>
                </center>
              </Grid>
            )}
          {billDetailsState.billedFrom === 0 &&
            billDetailsState.tripStatus !== TRIP_DELIVERED &&
            billDetails.isPaid &&
            !billDetailsState.settleDown && (
              <Grid item md={12} xs={12} sm={12} lg={12}>
                <center>
                  <p
                    style={{
                      whiteSpace: "pre-wrap",
                      overflowWrap: "break-word",
                      fontSize: "16px",
                      color: "#641906",
                    }}
                  >
                    <u>** Full Paid & Customer waiting for order **</u>
                  </p>
                </center>
              </Grid>
            )}
        </Grid>
        <Grid item md={3} xs={12} lg={3} sm={5}>
          <Typography
            variant="subtitle4"
            component="div"
            style={{
              color: "#2f1160",
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
              fontSize: "23px",
            }}
          >
            <u>Bill Summary:</u>
          </Typography>
          <Typography
            variant="subtitle4"
            component="div"
            style={{
              color: "#2f1160",
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
            }}
          >
            Sub Total: ₹{billPaymentDetails.totalPrice}
          </Typography>
          {billPaymentDetails.offerType === OfferType.Flat && (
            <Typography
              variant="subtitle4"
              component="div"
              style={{
                color: "rgb(189, 116, 67)",
                whiteSpace: "pre-wrap",
                overflowWrap: "break-word",
              }}
            >
              Offer Applied {"(- Flat )"} {billPaymentDetails.offerValue}
            </Typography>
          )}
          {billPaymentDetails.offerType === OfferType.Percentage && (
            <Typography
              variant="subtitle4"
              component="div"
              style={{
                color: "rgb(189, 116, 67)",
                whiteSpace: "pre-wrap",
                overflowWrap: "break-word",
              }}
            >
              Offer Applied {"(-)"} {billPaymentDetails.offerValue + " %"}
            </Typography>
          )}
          <Typography
            variant="subtitle4"
            component="div"
            style={{
              color: "#2f1160",
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
            }}
          >
            CGST{"(" + billPaymentDetails.cgst + "%):"} ₹
            {billPaymentDetails.cgstAmt}
          </Typography>
          <Typography
            variant="subtitle4"
            component="div"
            style={{
              color: "#2f1160",
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
            }}
          >
            SGST{"(" + billPaymentDetails.sgst + "%):"} ₹
            {billPaymentDetails.sgstAmt}
          </Typography>
          {(billPaymentDetails.roundOff !== 0.0 ||
            billPaymentDetails.roundOff !== -0.0) && (
              <Typography
                variant="subtitle4"
                component="div"
                style={{
                  color: "#A52A2A",
                  whiteSpace: "pre-wrap",
                  overflowWrap: "break-word",
                }}
              >
                RoundOff: {billPaymentDetails.roundOff > 0.0 ? "(+)" : "(-)"}{" "}
                {billPaymentDetails.roundOff}
              </Typography>
            )}
          {billDetailsState.isPointAdded && (
            <Typography
              variant="subtitle4"
              component="div"
              style={{
                color: "#A52A2A",
                whiteSpace: "pre-wrap",
                overflowWrap: "break-word",
              }}
            >
              Royality Point(-) ₹{billDetailsState.pointRedeem}
            </Typography>
          )}
          {billPaymentDetails.deliveryCharge > 0.0 && (
            <Grid item xs="auto">
              <Typography
                variant="subtitle4"
                component="div"
                style={{
                  color: "#A52A2A",
                  whiteSpace: "pre-wrap",
                  overflowWrap: "break-word",
                }}
              >
                Delivery Charge ₹{billPaymentDetails.deliveryCharge}
              </Typography>
            </Grid>
          )}
          <Typography
            variant="subtitle4"
            component="div"
            style={{
              color: "#2f1160",
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
            }}
          >
            Grand Total: ₹{billPaymentDetails.finalPrice}
          </Typography>
          <TextField
            id="cashTender"
            name="cashTender"
            variant="filled"
            size="small"
            inputProps={{
              inputMode: "decimal", // iOS & Android decimal keypad
              pattern: "[0-9]*[.,]?[0-9]*", // optional regex: allow decimals
            }}
            style={{ width: "70%" }}
            disabled={
              billDetails.isPaid ||
              (billPaymentDetails.isOnlinePayEnabled &&
                !billPaymentDetails.isCashPayEnabled) ||
              (!billPaymentDetails.isOnlinePayEnabled &&
                !billPaymentDetails.isCashPayEnabled) ||
              !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
            }
            label="Enter Cash Tender"
            value={billPaymentDetails.cashTender}
            onChange={handleInputChange}
            sx={{
              marginTop: 2,
            }}
          />
          {billPaymentDetails.cashReturn > 0.0 && (
            <Typography
              variant="subtitle4"
              component="div"
              style={{
                color: "#A52A2A",
                whiteSpace: "pre-wrap",
                overflowWrap: "break-word",
              }}
            >
              Cash Return: ₹{billPaymentDetails.cashReturn}
            </Typography>
          )}
        </Grid>
        {
          showPayDialog &&
          <PaymentDetailsDialog
            basrUrl={storeApiUrl.BACKEND_BASE_URL}
            paymentDetails={data}
            cartType={storeActiveShopHash.cartType}
            open={showPayDialog}
            onClose={() => setShowPayDialog(false)} />
        }

      </Grid>
    </div>
  );
};

export default BillDetailsSection;
